import React, { useState, useEffect, useLayoutEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
import { useDebounce } from 'react-use'
import { TextSubHeading } from 'blocket-ui'
import { mediaQueries } from '@blazar-plugins/device'

const AdsenseLabel = styled(TextSubHeading)`
  padding-left: 16px;
  padding-top: 16px;
  background-color: #f9f7f6;

  @media ${mediaQueries.medium} {
    border-top: none;
  }
`

const AdsenseContainer = styled.div`
  padding: 0;
  margin: 0;
  background-color: #f0f5fb;

  iframe {
    padding: 0;
    margin: 0;
    background-color: #f0f5fb;
    border-bottom: 1px solid #bab9b8;
    border-radius: 2px;
    display: block;
  }
`

const requestAfs = (afs, layout, emptySearchResults, windowWidth, setAdsLoaded) => {
  const deviceIsMedium = layout !== 'small'
  const styleId = deviceIsMedium ? '6509247428' : '6187630945'
  const containerHeight = deviceIsMedium ? 256 : 124
  let containerWidth
  if (deviceIsMedium) {
    containerWidth = 714
  } else if (windowWidth) {
    containerWidth = windowWidth
  } else if (window) {
    // This is for the initial value so that we don't have to change
    // windowWidth at render, triggering another call to google.
    containerWidth = window.innerWidth
  }

  if (!afs) {
    return
  }

  const afshBlock = {
    container: 'afsh-container',
    width: containerWidth,
    height: containerHeight,
    number: 1,
  }

  const afshChannel = emptySearchResults && afs.channel ? `${afs.channel}+zsrp` : afs.channel

  const pageOptions = {
    pubId: afs.pubId,
    query: afs.query,
    channel: afshChannel,
    adtest: afs.adtest,
    adsafe: 'high',
    styleId,
    adLoadedCallback: (containerName, eventAdsLoaded) => {
      setAdsLoaded(eventAdsLoaded)
    },
  }
  window._googCsa('plas', pageOptions, afshBlock)
}

const GoogleAdsense = (props) => {
  const afs = useSelector((state) => state?.classified?.searchResults?.inventory?.context?.afs)
  const [adsLoaded, setAdsLoaded] = useState(false)
  const [windowWidth, setWindowWidth] = useState(null)
  const { emptySearchResults, layout } = props

  useDebounce(
    () => {
      requestAfs(afs, layout, emptySearchResults, windowWidth, setAdsLoaded)
    },
    500,
    [windowWidth, afs],
  )

  useEffect(() => {
    const callback = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener('resize', callback)

    return () => {
      window.removeEventListener('resize', callback)
    }
  }, [layout, emptySearchResults, setAdsLoaded])

  useLayoutEffect(() => {
    setWindowWidth(window.innerWidth)
  }, [])

  if (afs && afs.query && afs.query.length > 0) {
    return (
      <>
        <Helmet>
          <script
            async="async"
            src="https://www.google.com/adsense/search/ads.js"
            type="text/javascript"
          ></script>
        </Helmet>
        <div style={adsLoaded ? {} : { display: 'none' }}>
          <AdsenseLabel>{props.label}</AdsenseLabel>
          <AdsenseContainer id="afsh-container" />
        </div>
      </>
    )
  }
  return null
}
GoogleAdsense.propTypes = {
  label: PropTypes.string,
  layout: PropTypes.string,
  emptySearchResults: PropTypes.bool,
}
export default GoogleAdsense
